import React from 'react'
import PropTypes from 'prop-types'
import { Col } from './Col'
import _ from 'lodash'
import styles from './ControlLayout.less'
import { pt } from 'common-data/proptypehelpers'
import { IconButton } from './IconButton'

const defaultLayout = {
  xs: 24,
  sm: 12,
  md: 8,
  lg: 6
}

export class ControlLayout extends React.Component {
  static propTypes = {
    WrappedCtrl: PropTypes.shape({
      meta: PropTypes.object,
      helpText: PropTypes.string,
      inputHelpers: pt.arrayOf(pt.shape({
        type: pt.string,
        onClick: pt.func,
        icon: pt.string,
        helpText: pt.string
      })),
      label: PropTypes.string,
      caption: PropTypes.string,
      layout: PropTypes.oneOfType([
        PropTypes.shape({
          all: PropTypes.number,
          xs: PropTypes.number,
          sm: PropTypes.number,
          md: PropTypes.number,
          lg: PropTypes.number
        }),
        PropTypes.bool
      ]),
      offSet: PropTypes.shape({
        all: PropTypes.number,
        xs: PropTypes.number,
        sm: PropTypes.number,
        md: PropTypes.number,
        lg: PropTypes.number
      }),
      className: PropTypes.any
    }).isRequired,
    children: PropTypes.node,
    variableHeightControl: PropTypes.bool,
    hide: PropTypes.bool.isRequired
  }

  static defaultProps = {
    variableHeightControl: false,
    helpButtons: [],
    hide: false
  }

  renderInputHelpers () {
    const { WrappedCtrl: { helpText, inputHelpers } } = this.props

    let helpers = []

    if (helpText) {
      helpers.push(<IconButton key='help' size='tiny' style={{ float: 'left' }} name='question' helpText={helpText} secondary={true} type='Info' />)
    }

    if (_.isArray(inputHelpers) === true) {
      _.each(inputHelpers, (b, i) => {
        helpers.push(<IconButton key={b.key} name={b.icon} size='tiny' style={{ float: 'left' }} helpText={b.helpText} secondary={b.secondary} type={b.type} onClick={b.onClick} />)
      })
    }

    return helpers
  }

  render () {
    const { WrappedCtrl: { meta, label, caption, layout, offSet, style, hide }, variableHeightControl } = this.props

    if (hide) {
      return null
    }

    let showError = (meta.touched || meta.submitFailed) && Boolean(meta.error)
    let errorMessage = showError ? meta.error || '' : ''

    let labelText = [<div key='lab' style={{ float: 'left' }}>{label}</div>, <div key='but' className={styles.inputHelperWrapper}>{this.renderInputHelpers()}</div>]

    let controlCss = `${styles.itemControl} ${showError ? styles.itemControlError : ''}`
    let labelCss = `${styles.itemLabel} ${showError ? styles.itemLabelError : ''}`
    let messageCss = `${styles.itemMessage} ${showError ? styles.itemMessageError : ''}`

    let controlStyle = {}

    if (variableHeightControl) {
      controlStyle.height = 'auto'
    }

    let hideLabel = _.isEmpty(label)

    var ctrl = (
      <div className={hideLabel ? styles.itemWrapperWithoutLabel : styles.itemWrapper}>
        {hideLabel ? null
          : <div className={labelCss}>
            {labelText}
          </div>
        }
        <div style={controlStyle} className={controlCss}>
          {this.props.children}
        </div>
        <div className={messageCss}>
          {showError ? errorMessage : caption || ''}
        </div>
      </div>
    )

    if (layout) {
      if (_.isBoolean(layout)) {
        return React.createElement(Col, { defaultLayout, style, offSet }, ctrl)
      } else {
        return React.createElement(Col, { layout, style, offSet }, ctrl)
      }
    }

    return ctrl
  }
}
